import { assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestGenerationUpdateName extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_GENERATION_UPDATE_NAME;

  generation_id: string;
  name!: string;

  /*
   * METHODS
   */

  constructor(generation_id = '') {
    super();

    this.generation_id = generation_id;
  }

  assert_standard_fields(): void {
    assert_string_object_id(this.generation_id);
  }
}
